import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Login from '../pages/Login'
import Manage from '../pages/Manage'
import AccountManage from '../pages/system/AccountManage'
import RoleManage from '../pages/system/RoleManage'
import SystemLog from '../pages/system/SystemLog'
import DataManage from '../pages/enroll/DataManage'
import FormManage from '../pages/enroll/FormManage'

let routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录'
        },
        children: []
    },
    {
        path: '/',
        name: 'Manage',
        component: Manage,
        meta: {
            title: '管理'
        },
        children: [
            {
                path: '/system-manage/account',
                name: 'AccountManage',
                component: AccountManage,
                meta: {
                    title: '系统管理'
                },
            },
            {
                path: '/system-manage/role',
                name: 'RoleManage',
                component: RoleManage,
                meta: {
                    title: '角色管理'
                },
            },
            {
                path: '/system-manage/log',
                name: 'SystemLog',
                component: SystemLog,
                meta: {
                    title: '系统日志'
                },
            },
            {
                path: '/enroll-manage/data',
                name: 'DataManage',
                component: DataManage,
                meta: {
                    title: '数据管理'
                },
            },
            {
                path: '/enroll-manage/form',
                name: 'FormManage',
                component: FormManage,
                meta: {
                    title: '表单管理'
                },
            }
        ]
    }
]

const router = new VueRouter({
    // mode: 'history',
    routes: routes,
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router
